import React, { useEffect, useState } from 'react'
import { Warning as WarningIcon } from '@mui/icons-material';
import * as S from './styles';
import { ProcurementStatusEnum } from '@/main/services/enum/StatusProcurement';
import ColumnLabel from '@/main/components/common/columnLabel/columnLabel';
import { getTranslateByKey, isEmpty, isNullUndefined, isShowControlByElementId } from '@/main/services/utils';
import RowLabel from '@/main/components/common/rowLabel/rowLabel';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { RowFlex, SkeletonLoading, SpinnerLoading } from '@/main/components/shared/styles';
import { CircularProgress } from '@mui/material';
import colors from '@/main/style/colors';
import { PossibleTotalLossIcon } from '@/main/components/shared/icons';
import { Controls } from '@/main/services/constants/constantsControl';
import { quoteApi } from '@/main/api';
import { QuoteTotalLossResponse } from '@/main/models/response';

interface ITotalLossComponentProps {
  idStatus?: number;
  type?: 'column' | 'row';
  guidQuote: string;
  refreshKey?: number;
}

interface ITotalLossTextProps extends ITotalLossComponentProps {
  totalLoss: string;
  possibleTotalLoss: boolean;
}

function TotalLossText({
  idStatus,
  totalLoss,
  possibleTotalLoss
}: ITotalLossTextProps) {
  const showIcon = possibleTotalLoss && idStatus != ProcurementStatusEnum.Cancelled;

  const formattedText = isEmpty(totalLoss) ? '-' : `${totalLoss}%`;
  return (
    <S.Container title={formattedText}>
      {formattedText}
      {showIcon && (
        <PossibleTotalLossIcon possibleTotalLoss={possibleTotalLoss} />
      )}
    </S.Container>
  )
}



function TotalLossComponent(props: ITotalLossComponentProps) {
  const [resultTotalLoss, setResultTotalLoss] = useState<null | QuoteTotalLossResponse>(null);
  const [isLoading, setIsLoading] = useState(false);

  async function loadTotalLoss() {
    setIsLoading(true);
    quoteApi
      .getTotalLossByGuidQuote(props.guidQuote)
      .then(response => {
        if (response && response.data && response.data.result) {
          setResultTotalLoss(response.data.result);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  useEffect(() => {
    loadTotalLoss();
  }, [props.guidQuote, props.idStatus, props.refreshKey])

  const newProps: ITotalLossTextProps = {
    ...props,
    totalLoss: !isNullUndefined(resultTotalLoss?.totalLoss) ? `${resultTotalLoss.totalLoss}` : '',
    possibleTotalLoss: !isNullUndefined(resultTotalLoss?.possibleTotalLoss) ? resultTotalLoss.possibleTotalLoss : false,
  }

  if (props.type === 'column') {
    return (
      <ColumnLabel
        label={getTranslateByKey("information.totalLoss")}
        content={isLoading ? <CircularProgress size={14} /> : <TotalLossText {...newProps} />}

      />
    )
  }

  return <RowLabel label={getTranslateByKey("information.totalLoss")} content={isLoading ? <CircularProgress size={14} /> : <TotalLossText {...newProps} />} />

}

export default TotalLossComponent